import { useEffect } from 'react';

import { appConfig } from 'shared/config';

export const useSetTitle = ({ title }: { title: string }) => {
  useEffect(() => {
    document.title = `${title} | ${appConfig.organisationName()}`;
  }, [title]);
};
